import type { ReactNode } from "react";

import { config } from "./config";
import type { ScreenId } from "./game/types";
import { ConnectionStrip, Toast } from "./ui/components/common";
import { useGame } from "./ui/context";
import { CollectionsScreen } from "./ui/screens/CollectionsScreen";
import { ConnectScreen } from "./ui/screens/ConnectScreen";
import { FiltersScreen } from "./ui/screens/FiltersScreen";
import { InviteScreen } from "./ui/screens/InviteScreen";
import {
  FatalScreen,
  LoadingScreen,
  NoMatchScreen,
  NoTelegramScreen,
  SubscribeScreen,
} from "./ui/screens/simple";
import { StartScreen } from "./ui/screens/StartScreen";
import { SwipeScreen } from "./ui/screens/SwipeScreen";
import { WaitingScreen } from "./ui/screens/WaitingScreen";

const SCREENS: Record<ScreenId, () => ReactNode> = {
  loading: () => <LoadingScreen />,
  "no-telegram": () => <NoTelegramScreen />,
  fatal: () => <FatalScreen />,
  subscribe: () => <SubscribeScreen />,
  start: () => <StartScreen />,
  collections: () => <CollectionsScreen />,
  connect: () => <ConnectScreen />,
  invite: () => <InviteScreen />,
  waiting: () => <WaitingScreen />,
  filters: () => <FiltersScreen />,
  swipe: () => <SwipeScreen />,
  "no-match": () => <NoMatchScreen />,
};

export function App() {
  const screen = useGame((s) => s.screen);
  const hasBanner = config.bannerText !== "";
  return (
    <div className={hasBanner ? "app" : "app app--no-banner"}>
      <div className="app__container">
        {hasBanner && <div className="banner">{config.bannerText}</div>}
        {SCREENS[screen]()}
      </div>
      <ConnectionStrip />
      <Toast />
    </div>
  );
}
